const WA_SALES_NUMBER = "5491168090746";

export function buildLeadWhatsAppUrl(input: {
  nombre?: string;
  negocio?: string;
  email?: string;
  telefono?: string;
  planInteresado?: string;
}): string {
  const planLabel = input.planInteresado?.trim() || "desconocido";
  const msg = encodeURIComponent(
    `🔔 *Nuevo lead — Structura Market*\n\n` +
      `👤 *Nombre:* ${input.nombre?.trim() ?? ""}\n` +
      `🏢 *Negocio:* ${input.negocio?.trim() ?? ""}\n` +
      `📧 *Email:* ${input.email?.trim() ?? ""}\n` +
      `📱 *Teléfono:* ${input.telefono?.trim() ?? ""}\n` +
      `📦 *Plan interesado:* ${planLabel}\n\n` +
      `Responder al: ${input.telefono?.trim() ?? ""}`,
  );
  return `https://wa.me/${WA_SALES_NUMBER}?text=${msg}`;
}
